/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Sug_IntroInputs */

const en_chat_sug_intro = /** @type {(inputs: Chat_Sug_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What does Sohan do?`)
};

const ar_chat_sug_intro = /** @type {(inputs: Chat_Sug_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ماذا يفعل سهان؟`)
};

const bn_chat_sug_intro = /** @type {(inputs: Chat_Sug_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সোহান কী করে?`)
};

const de_chat_sug_intro = /** @type {(inputs: Chat_Sug_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was macht Sohan?`)
};

const es_chat_sug_intro = /** @type {(inputs: Chat_Sug_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué hace Sohan?`)
};

const fr_chat_sug_intro = /** @type {(inputs: Chat_Sug_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que fait Sohan ?`)
};

const pt_chat_sug_intro = /** @type {(inputs: Chat_Sug_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que Sohan faz?`)
};

const zh_chat_sug_intro = /** @type {(inputs: Chat_Sug_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sohan 做什么？`)
};

const tr_chat_sug_intro = /** @type {(inputs: Chat_Sug_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sohan ne yapıyor?`)
};

const ru_chat_sug_intro = /** @type {(inputs: Chat_Sug_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чем занимается Сохан?`)
};

const pl_chat_sug_intro = /** @type {(inputs: Chat_Sug_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co robi Sohan?`)
};

/**
* | output |
* | --- |
* | "What does Sohan do?" |
*
* @param {Chat_Sug_IntroInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const chat_sug_intro = /** @type {((inputs?: Chat_Sug_IntroInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Sug_IntroInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_chat_sug_intro(inputs)
	if (locale === "bn") return bn_chat_sug_intro(inputs)
	if (locale === "de") return de_chat_sug_intro(inputs)
	if (locale === "es") return es_chat_sug_intro(inputs)
	if (locale === "fr") return fr_chat_sug_intro(inputs)
	if (locale === "pt") return pt_chat_sug_intro(inputs)
	if (locale === "zh") return zh_chat_sug_intro(inputs)
	if (locale === "tr") return tr_chat_sug_intro(inputs)
	if (locale === "ru") return ru_chat_sug_intro(inputs)
	if (locale === "pl") return pl_chat_sug_intro(inputs)
	return en_chat_sug_intro(inputs)
});